<div class="container">
  <div class="new-header small-header">

    <div class="top-menu">
      <div class="menu-left">
        <a [routerLink]="['/smart-cities-suppliers', supplierId]">
          <span>{{supplierName}}</span>
        </a>

      </div>

      <div class="menu-right">

        <mat-menu #appMenu="matMenu" yPosition="below">
          <button mat-menu-item (click)="onClickPublicProfile()">
            <span class="text-capitalize" [translate]="'painel-dashboard/public-profile'"></span>
          </button>
          <button *ngIf="userCanAccessOpportunitiesMap()" mat-menu-item (click)="onClickOpportunities()">
            <span class="text-capitalize" [translate]="'painel-dashboard/opportunities'"></span>
          </button>
          <button *ngIf="canAccess()" mat-menu-item (click)="onClickSolutions()">
            <span class="text-capitalize" [translate]="'painel-dashboard/solutions'"></span>
          </button>
          <button *ngIf="canAccess()" mat-menu-item (click)="onClickEditSupplier()">
            <span class="text-capitalize" [translate]="'edit-supplier/title'"></span>
          </button>
          <!-- <button *ngIf="canAccess()" mat-menu-item (click)="onClickUsers()">
            <span class="text-capitalize" [translate]="'navigation/users'"></span>
          </button> -->
        </mat-menu>

        <button mat-icon-button [matMenuTriggerFor]="appMenu" class="hidden-md-up">
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>

        <ul class="hidden-sm-down">
          <li (click)="onClickPublicProfile()" [class.active]="menuItem == 1"><a class="text-uppercase" [translate]="'painel-dashboard/public-profile'"></a></li>
          <li *ngIf="userCanAccessOpportunitiesMap()" (click)="onClickOpportunities()" [class.active]="menuItem == 2"><a class="text-uppercase" [translate]="'painel-dashboard/opportunities'"></a></li>
          <li *ngIf="canAccess()" (click)="onClickSolutions()" [class.active]="menuItem == 3"><a class="text-uppercase" [translate]="'painel-dashboard/solutions'"></a></li>
          <li *ngIf="canAccess()"(click)="onClickEditSupplier()" [class.active]="menuItem == 4"><a class="text-uppercase" [translate]="'edit-supplier/title'"></a></li>
          <!-- <li *ngIf="canAccess()" (click)="onClickUsers()" [class.active]="menuItem == -1"><a class="text-uppercase" [translate]="'navigation/users'"></a></li> -->
        </ul>

      </div>
    </div>


    <div class="alert-bar">
      <div class="alert alert-warning" *ngIf="(this.menuItem == 4)  && !canAccess()">
        <i class="icon ion-md-alert"></i>
        <span [translate]="'supplier-menu/alert-canManage'">Aguardando confirmação dos seus dados para liberar a administração da sua empresa</span>
      </div>
      <div class="alert alert-warning" *ngIf="userService.isSuspendedPayment()">
        <i class="icon ion-md-alert"></i>
        <span class="m-3" [translate]="'supplier-menu/alert-suspended-payment'">Não identificamos o pagamento da sua última fatura e sua conta foi suspensa.</span>
        <a [routerLink]="['/account']"><span [translate]="'supplier-menu/manager-account'"></span></a>
      </div>
      <div class="alert alert-warning" *ngIf="userService.hasNoSubscription()">
        <i class="icon ion-md-alert"></i>
        <span class="m-3" [translate]="'supplier-menu/alert-no-plan'">Atualmente, sua conta não está vinculada a nenhum plano. No entanto, você tem a liberdade de cadastrar soluções e editar as informações da sua empresa. Ao aderir a um de nossos planos, você desbloqueará novos benefícios: seu perfil se tornará visível para outros usuários e suas soluções serão destacadas em nosso marketplace, ampliando significativamente a visibilidade e o alcance do seu negócio.</span>
        <a [routerLink]="['/choose-plan']"><span [translate]="'supplier-menu/choose-plan'"></span></a>
      </div>
    </div>
  </div>
</div>